export default {"src":"/_next/static/media/lentils.cd6ce7f2.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};